
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import MobileNavigation from '../../mobile-navigation'
import "../styles/Navigation.sass"
import icon from '../../../../images/icons/mystery-icon-white.svg'
import NavLink from './NavLink'
import { colors } from '../../../../assets/colors'
import { useLocation } from '@reach/router';

const RetroBars = () => (
  <div className="retro-bars">
    {Object.keys(colors.retro).map((c) => (
      <div style={{
        backgroundColor: colors.retro[c]
      }}></div>
    ))}
  </div>
)

const Logo = () => (
  <a className="logo" href="https://khalilstemmler.com/">
    <img src={icon} />
    <p>khalilstemmler.com</p>
  </a>
)

const Links = () => {
  const location = useLocation();
  const resourcesLink = location.pathname === '/' ? '#resources' : '/resources';

  return (
    <div className="links">
      <NavLink to={resourcesLink} displayValue="Resources"/>
      <NavLink to="/articles" displayValue="Articles" />
      <NavLink to="/phases-quiz" displayValue="Quiz" />
      <NavLink to="https://tally.so/r/mDqK55" displayValue="Mentorship" />
      <NavLink to="https://discord.gg/MyhQXMvZCr" displayValue="Community" /> 
      {/* <NavLink to="https://twitter.com/khalilstemmler" displayValue="X" />
      <NavLink to="http://github.com/stemmlerjs" displayValue="GitHub" />
      */}
    </div>
  )
}

function useNavigation () {
  const [scrolled, setScrolled] = useState(false);
  const addScrollEventListener = () => {
    typeof window !== 'undefined'
      && window.addEventListener('scroll', navOnScroll.bind(this))
  }

  const removeScrollEventListener = () => {
    typeof window !== 'undefined'
        && window.removeEventListener('scroll', navOnScroll.bind(this))
  }

  const navOnScroll = () => {
    if (window.scrollY > 20) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  }

  useEffect(() => {
    addScrollEventListener();
    return () => removeScrollEventListener()
  }, [])

  return { scrolled }
}

function Navigation (props) {
  const { scrolled } = useNavigation();
  const { rawMode } = props;
  
  return (
    <>
      <MobileNavigation
        scrolled={scrolled}
        topOffset={scrolled ? '16px' : '27px'}
      />

    {/* <div style={{
      position: 'fixed',
      background: '#6b1eff',
      display: 'block',
      zIndex: 99,
      color: 'white',
      width: '100%',
      left: 0,
      height: '3rem',
      paddingBottom: '0rem',
      fontSize: '0.9rem',
      fontFamily: 'TriplettCGBlack'
    }}>
        <div style={{
          animation: `marqueeAnimation 15s linear infinite`
        }}>Black Friday Sale Live </div>
        <div className='marquee-bottom-text'>Get 25% off all courses until December 1st</div>
    </div> */}

      {!rawMode ? (
        <div className={scrolled ? "navigation scroll" : "navigation"}>
          <div className="navigation-inner">
            <Logo/>
            <Links/>
          </div>
          {/* <RetroBars /> */}
        </div>
      ) : ''}
    </>
  )
}

export default Navigation;

Navigation.propTypes = {
  rawMode: PropTypes.bool
}